import React from "react";
import { COST_COLORS } from "@/lib/costColors";

// Colorize a derivation string so every cost component reads in its standard color
// (owner: "assign a color to everything and show that color" in every calc breakdown).
// Maps each label phrase -> COST_COLORS key; multi-word/longer phrases win first.
const LABEL_KEY = [
  ["general conditions", "general_conditions"],
  ["per-diem", "per_diem"],
  ["per diem", "per_diem"],
  ["subcontractor", "subcontract"],
  ["subcontract", "subcontract"],
  ["mobilization", "mobilization"],
  ["management", "management"],
  ["environmental", "environmental"],
  ["allowances", "allowances"],
  ["allowance", "allowances"],
  ["contingency", "contingency"],
  ["materials", "material"],
  ["material", "material"],
  ["equipment", "equipment"],
  ["warranty", "warranty"],
  ["perdiem", "per_diem"],
  ["profit", "profit"],
  ["markup", "profit"],
  ["labor", "labor"],
  ["travel", "per_diem"],
  ["enviro", "environmental"],
  ["bond", "bond"],
  ["tax", "tax"],
];

const KEY_OF = Object.fromEntries(LABEL_KEY);
const PHRASES = LABEL_KEY.map(([p]) => p).sort((a, b) => b.length - a.length);
const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const RE = new RegExp(`(${PHRASES.map(esc).join("|")})(\\s*\\$[\\d,]+(?:\\.\\d+)?)?`, "gi");

export function colorizeCost(text) {
  if (typeof text !== "string" || !text) return text;
  const out = [];
  let last = 0;
  let m;
  RE.lastIndex = 0;
  while ((m = RE.exec(text)) !== null) {
    if (m[0].length === 0) { RE.lastIndex++; continue; }
    if (m.index > last) out.push(text.slice(last, m.index));
    const color = COST_COLORS[KEY_OF[m[1].toLowerCase()]];
    out.push(<span key={m.index} style={{ color, fontWeight: 600 }}>{m[0]}</span>);
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export function CostFormula({ text, className }) {
  return <span className={className}>{colorizeCost(text)}</span>;
}
